import { useQuery, type UseQueryOptions } from "@tanstack/react-query";
export const InvoiceV2OpenApi = {
  DownloadPdfBySecret: {
    useQuery: (secret: string, fileName: string, inline: boolean, opts: UseQueryOptions<any>) => useQuery({
      queryKey: ["InvoiceV2Open.DownloadPdfBySecret", secret, fileName, inline],
      queryFn: () => window.CoreApi.InvoiceV2Open.DownloadPdfBySecret(secret, fileName, inline).then(r => r.data),
      ...opts
    }),
    getCacheKey: (secret: string, fileName: string, inline: boolean) => ["InvoiceV2Open.DownloadPdfBySecret", secret, fileName, inline]
  }, 
  PreviewDocument: {
    useQuery: (secret: string, opts: UseQueryOptions<server.dto.ApiResponseWrapper<string>>) => useQuery({
      queryKey: ["InvoiceV2Open.PreviewDocument", secret],
      queryFn: () => window.CoreApi.InvoiceV2Open.PreviewDocument(secret).then(r => r.data),
      ...opts
    }),
    getCacheKey: (secret: string) => ["InvoiceV2Open.PreviewDocument", secret]
  }, 

}
